<template>
  <v-app>
    <router-view />
    <v-dialog v-model="restoreStatus" persistent max-width="370">
      <v-card>
        <v-card-text class="py-3">
          <div class="d-flex justify-center pb-3">
            <div class="warning-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                ></path>
              </svg>
            </div>
          </div>
          <p class="mb-0 text-center font-weight-bold">コンテンツをコピー中です。</p>
          <p class="mb-0 text-center font-weight-bold">少々お待ちください。</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
export default {
  name: "App",
  store: ["restoreStatus"],
  watch: {
    restoreStatus: function (val) {
      console.log("val: ", val);
    },
  },
};
</script>
<style scoped>
@font-face {
  font-family: "Dosis";
  src: url("./assets/fonts/Dosis-VariableFont-wght.ttf");
  /* font-size: 20px; */
}
body {
  font-size: 20px;
}
.warning-icon {
  width: 2.5rem;
  display: flex;
  background-color: #fb8c0045;
  align-items: center;
  justify-content: center;
  padding: 7px;
  border-radius: 50%;
}
.warning-icon svg {
  height: 24px;
  width: 24px;
  color: #fb8c00;
}
</style>